module.exports = __webpack_public_path__ + "media/images/bnr_recommend_email_campaign-9baaca164f093a234e1dc33d7b1e0b75.jpg";